<template>
  <v-dialog :value="newPopup" persistent max-width="840">
    <v-card>
      <v-card-text class="px-md-8 pt-5">
        <h4 class="font font--h2-2  mb-2">Привет, Партнер!</h4>

        <p class="font font--p-sm mb-2">
          За прошедший год наша партнерская программа существенно преобразилась. Мы задаем новые стандарты качества
          работы с партнерами, и самый важный из них - это обязательство моментальных выплат вознаграждения.
        </p>

        <p class="font font--p-sm mb-2">
          Для того, чтобы сохранить скорость выплат и качество обслуживания, мы решили выделить проект в отдельную
          компанию - МодульПартнер. Это решение избавит нас от банковской бюрократии, и позволит нам продолжать делать
          моментальные выплаты любому количеству партнеров в любое время.
        </p>

        <p class="font font--p-sm mb-2">
          Фактически для вас ничего не изменится: ни в условиях, ни в сервисе. Формально изменится оферта и все расчеты
          будут теперь с компанией МодульПартнер. Для дальнейшей работы просто перезаключите оферту.
        </p>

        <p class="font font--p-sm mb-2">
          Спасибо за доверие и работу!
        </p>

        <div class="d-flex flex-column">
          <a href="/files/offerta.pdf" target="_blank"
            ><v-icon color="primary" size="15">mdi-arrow-collapse-down</v-icon> Согласие</a
          >
          <a href="https://modulbank.ru/fs/files/oferta_modulpartner.pdf" target="_blank"
            ><v-icon color="primary" size="15">mdi-arrow-collapse-down</v-icon> Оферта</a
          >
          <a href="https://modulbank.ru/fs/files/tarrifs_modulpartner.pdf" target="_blank"
            ><v-icon color="primary" size="15">mdi-arrow-collapse-down</v-icon> Тарифы</a
          >
        </div>
        <v-checkbox v-model="newOfferta" color="#88BD1F" hide-details class="mb-1">
          <template v-slot:label>
            <div class="font font--p-sm">Я согласен(-на)</div>
          </template>
        </v-checkbox>
      </v-card-text>
      <v-card-actions class="justify-center pb-4">
        <v-btn @click="closePopup" color="primary" min-width="210" :disabled="!newOfferta" large
          >Перезаключить оферту</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
import { updateAgreement } from "@/api";

export default {
  data() {
    return {
      newOfferta: false,
    };
  },
  methods: {
    async closePopup() {
      await updateAgreement();
      this.$router.go();
    },
  },
  computed: {
    ...mapGetters({
      newPopup: "profile/canSeeNewOffertaPopup",
    }),
  },
};
</script>
<style scoped>
a {
  text-decoration: none;
}
</style>
